export const themeModes = ['light', 'dark', 'system'] as const
export const palettes = [
  {
    id: 'forgesphere',
    label: 'Deep Navy',
    description: 'Cool paper, deep navy night. The default.',
  },
  {
    id: 'indigo',
    label: 'Indigo Slate',
    description: 'Warm paper, indigo night.',
  },
  {
    id: 'warm',
    label: 'Warm Ink',
    description: 'Cream paper, warm ink. The same hue by day and night.',
  },
  {
    id: 'graphite',
    label: 'Graphite',
    description: 'Cool white, neutral night. Nothing competes with the orange.',
  },
  {
    id: 'midnight',
    label: 'Midnight',
    description: 'Crisp paper, near-black night. The highest contrast pair.',
  },
  {
    id: 'aubergine',
    label: 'Aubergine',
    description: 'Lilac paper, violet night. Accents burn hardest here.',
  },
  {
    id: 'cupcake',
    label: 'Cupcake',
    description: 'Cream paper, plum ink, teal night. The ink is not a black.',
  },
  {
    id: 'retro',
    label: 'Retro',
    description:
      'Aged tan paper, espresso night. The most tinted paper of the eleven.',
  },
  {
    id: 'luxury',
    label: 'Luxury',
    description:
      'Ivory day, black and gold night. The only ground that prints gold.',
  },
  {
    id: 'lemonade',
    label: 'Lemonade',
    description: 'Pale green paper, olive night. The only green pair.',
  },
  {
    id: 'winter',
    label: 'Winter',
    description: 'The bluest paper here, over a cold steel night.',
  },
] as const
export const accents = [
  { id: 'ember', label: 'Ember' },
  { id: 'verdigris', label: 'Verdigris' },
  { id: 'iris', label: 'Iris' },
  { id: 'mulberry', label: 'Mulberry' },
] as const
export interface ThemePreferences {
  mode: (typeof themeModes)[number]
  palette: (typeof palettes)[number]['id']
  accent: (typeof accents)[number]['id']
}
export const themeStorageKey = 'fs_theme_preferences'
export const defaultTheme: ThemePreferences = {
  mode: 'dark',
  palette: 'forgesphere',
  accent: 'ember',
}

export function parseThemePreferences(value: unknown): ThemePreferences {
  const input =
    value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
  return {
    mode: themeModes.find((mode) => mode === input.mode) ?? defaultTheme.mode,
    palette:
      palettes.find((palette) => palette.id === input.palette)?.id ??
      defaultTheme.palette,
    accent:
      accents.find((accent) => accent.id === input.accent)?.id ??
      defaultTheme.accent,
  }
}
